<template>
  <div class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <!-- 共通ヘッダー -->
    <HeaderNav menuflg="0" />
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
    _/                                                                                                                    _/
    _/      画面定義                                                                                                      _/
    _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
      <div class="body">
          <div class="inner mb-20px">
              <div class="pankuzu">
                  <ul>
                      <li>
                      <span class="ico-home current">メインページ</span>
                      </li>
                  </ul>
              </div>
              <div class="content-header">
              <h1 class="h1">電帳法オプションへようこそ</h1>
              </div>
              <p class="lead">このサービスは、電子帳簿保存法の電子取引区分に対応したファイル保管サービスです。<br>取引先情報等をもとに簡単に検索することができます。</p>
          </div>
    <!--                          -->
          <div class="inner mb-20px">
              <div class="inner block">
                  <h2 class="h2">ファイル管理の流れ</h2>
                  <!-- step -->
                  <div style="justify-content: flex-start;" class="step">
                      <div class="step-item">
                          <p class="step-title">STEP1</p>
                          <p class="step-explain">書類を収集する事業者を登録します。</p>
                          <div class="step-image">
                              <img
                                  src="@/assets/images/denchouhou/pict_step01.png"
                                  width="218"
                                  height="90"
                                  alt
                              />
                          </div>
                          <div class="step-btn">
                              <a
                                  href="#"
                                  class="frm-btn strong large"
                                  @click.prevent="handleCompanyInfoRegist"
                                  ref="companyInfoRegistButton"
                                  >事業者情報の登録</a
                              >
                          </div>
                      </div>
                      <div class="step-item">
                          <p class="step-title">STEP2</p>
                          <p class="step-explain">電子取引データ等のファイルを登録します。</p>
                          <div class="step-image">
                              <img
                                  src="@/assets/images/denchouhou/pict_step02.png"
                                  width="218"
                                  height="90"
                                  alt
                              />
                          </div>
                          <div class="step-btn">
                              <a
                                  href="#"
                                  class="frm-btn strong large"
                                  @click.prevent="handleFileManage"
                                  >ファイルの管理</a
                              >
                          </div>
                      </div>
                  </div>
                  <!-- step // -->
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import HeaderNav from "@/components/AccountingHeader.vue";
import { API_STFMFM01C01 } from "@/api/Modules/FM01/STFMFM01C01.js";
import { mapMutations } from "vuex";
export default {
  name: "STFMFM01C01",
  components: {
    HeaderNav,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.processDialogue(true);
    this.initFocus();
    API_STFMFM01C01().then((response) => {
      this.processDialogue(false);
      if (response.result == "0000") {
      } else {
        this.$router.push({
          name: "STDSCM04C06",
          params: {
            demo: Common.getMessage(response.errorCD, []),
          },
        });
      }
    });
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue"]),

      // **********************************************
      // * 事業者情報の登録
      // **********************************************
      handleCompanyInfoRegist() {
          this.$redirect({ name: "STDSDC02C01" });
      },
      // **********************************************
      // * ファイル管理
      // **********************************************
      handleFileManage() {
          this.$redirect({ name: "STFMFM02C01" });
      },
      // **********************************************
      // * 初期フォーカス設定
      // **********************************************
      initFocus() {
        this.$refs.companyInfoRegistButton.focus();
      },
  },
};
</script>

<style scoped>
@media screen and (max-width: 1400px) {
  .body>.inner,.content-body2>.inner{
    max-width: none !important;
  }
}
</style>